'use strict';
var commonBoutiqueCN = require('./_commonBoutiqueCN');
var base = require('./base');
var urlUtil = require('./../common/urlUtil');

function countrySelect(Url, countryCode, displayValue) {
    var queryParams = urlUtil.getQueryParams();
    var queryString = base.createQueryParam(queryParams);
    $.spinner().start();
    $.ajax({
        url: Url,
        method: 'GET',
        data: 'countryCode=' + countryCode + queryString,
        success: function (data) {
            base.updateboutiques(data.filterListHtml, displayValue);
            base.activeFeFilter();
            $.spinner().stop();
            commonBoutiqueCN.createMap(data.filterList, false, countryCode);
        }
    });
}

module.exports = {
    telephonLink: function() {
        $(document).on('click', '.js-select-boutiques .js-telephone-boutique', function(e) {
            var boutiqueID = $(this).attr('data-id');
            var boutiqueName = $(this).attr('data-name');
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'boutique locator service',
                eventAction: 'detail',
                eventLabel: 'call',
                boutiqueName: boutiqueName + '–' + boutiqueID
            });
            e.stopPropagation();
        });
    },

    mobileButton: function () {
        $(document).ready(function () {
            if ($('body').hasClass('cc-mobile')) {
                $('.cc-boutiques-opened-desktop-tab').css('visibility', 'hidden');
                $('.cc-boutiques-opened-mobile').css('visibility', 'visible');
                $('.cc-boutiques-opened-mobile').css('display', 'block');
            } else {
                $('.cc-boutiques-opened-mobile').css('visibility', 'hidden');
                $('.cc-boutiques-opened-mobile').css('display', 'none');
            }
        });
    },

    currentContry: function () {
        $(document).ready(function () {
            var currentCountry = currentCountryCode;
            var displayValue = $('#js-boutiques-selectCountry').attr('name');
            var url = $('.cc-content-select').data('findboutiques');
            $('#js-boutiques-selectCountry').val(currentCountry);
            countrySelect(url, currentCountry, displayValue);
        });
    },

    checkBoutiquefilter: function () {
        $(document).on('click', '.cc-service-filter .cc-service-items', function () {
            var active = $(this).hasClass('cc-active-iteams');
            if (active) {
                $(this).removeClass('cc-active-iteams').find('button').attr('aria-selected', 'false');
            } else {
                $(this).addClass('cc-active-iteams').find('button').attr('aria-selected', 'true');
            }
        });
    },

    selectBoutiques: function () {
        $(document).on('click', '.js-active-search', function () {
            var boutiqueID = this.dataset.boutiqueid;
            $('.cc-single-boutiques-result').removeClass('cc-active-live-search');
            $('.js-boutique-' + boutiqueID).addClass('cc-active-live-search');
        });
    },

    filterBoutique: function() {
        $(document).on('click', '.js-filter-event .cc-service-items', function () {
            var url = $('.js-boutique-filter-url').data('filterboutique');
            var returned = $('#js-boutique-filter-returned').hasClass('cc-active-iteams');
            var repair = $('#js-boutique-filter-repair').hasClass('cc-active-iteams');
            var sartoria = $('#js-boutique-filter-sartoria').hasClass('cc-active-iteams');
            var pikup = $('#js-boutique-filter-pickup').hasClass('cc-active-iteams');
            var fragrances = $('#js-boutique-filter-fragrances').hasClass('cc-active-iteams');
            var countryCode = $('#js-boutiques-selectCountry').val();
            var countryDisplayValue = $('.cc-findBoutique-select .filter-option-inner-inner').text();
            $.ajax({
                url: url,
                method: 'GET',
                data: {
                    countryCode: countryCode,
                    returned: returned,
                    repair: repair,
                    sartoria: sartoria,
                    pickup: pikup,
                    fragrances: fragrances
                },
                success: function (data) {
                    base.updateboutiques(data.boutiquesFilteredHtml, countryDisplayValue);
                    base.updateQueryParam();
                    commonBoutiqueCN.createMap(data.boutiquesFiltered, false, countryCode);
                }
            });
        });
    }
};
